import companiesApi from "@/api/companies";
const state = {
    isCustomerEmailRequired: false,
    isCustomerDayOfBirthdayRequired: false
};
const actions = {
    async getCompanyInfo(context) {
        const response = await companiesApi.getInfo();
        context.commit("setCompanyInfo", response);
    }
};
const getters = {
    isCustomerEmailRequired(state) {
        return state.isCustomerEmailRequired;
    },
    isCustomerDayOfBirthdayRequired(state) {
        return state.isCustomerDayOfBirthdayRequired;
    }
};
const mutations = {
    setCompanyInfo(state, companyInfo) {
        state.isCustomerEmailRequired = companyInfo?.isCustomerEmailRequired ?? false;
        state.isCustomerDayOfBirthdayRequired = companyInfo?.isCustomerDayOfBirthdayRequired ?? false;
    }
};
export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
